import { createContext } from 'react';

import type { ViewedOrganization } from '@/api/viewing-scope';

export interface ViewingContextValue {
  /** The organization being viewed read-only, or null. */
  viewing: ViewedOrganization | null;
  /** Start viewing an organization. Does nothing for anybody but staff. */
  enter: (organization: ViewedOrganization) => void;
  /** Stop viewing. */
  exit: () => void;
  /**
   * True between starting a view and the first organization page showing.
   * Any staff page ends a view - however it was reached, Exit or the browser's
   * Back button - except the one View portal was pressed on, which is still on
   * screen until the router moves on.
   */
  arriving: boolean;
  /** Say that an organization page is showing, so a staff page now ends the view. */
  arrived: () => void;
}

/**
 * In its own file, separate from the provider component: a file exporting both
 * a component and a non-component value breaks Vite's hot reloading.
 */
export const ViewingContext = createContext<ViewingContextValue | null>(null);
